import { Link } from "react-router-dom";
import { FiArrowUpRight, FiMail } from "react-icons/fi";
import "./SiteFooter.css";

function SiteFooter() {
  return (
    <footer className="SiteFooter">
      <div>
        <Link className="SiteFooterName" to="/">Jérôme Lecoq</Link>
        <p>Neuroscience, open platforms, and notes in public.</p>
      </div>
      <nav aria-label="Footer navigation">
        <Link to="/blog">Blog</Link>
        <a href="https://alleninstitute.org/person/jerome-lecoq/" target="_blank" rel="noreferrer">
          Allen Institute <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="https://www.linkedin.com/in/lecoqjerome/?locale=en" target="_blank" rel="noreferrer">
          LinkedIn <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="https://scholar.google.com/citations?user=qEadPMEAAAAJ&hl=en" target="_blank" rel="noreferrer">
          Google Scholar <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="/academic-cv.pdf" target="_blank" rel="noreferrer">
          Academic CV <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="https://x.com/LecoqJerome" target="_blank" rel="noreferrer">
          Twitter <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="https://orcid.org/0000-0002-0131-0938" target="_blank" rel="noreferrer">
          ORCID <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="https://neurotree.org/neurotree/peopleinfo.php?pid=82399" target="_blank" rel="noreferrer">
          Neurotree <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="https://bsky.app/profile/jeromelecoq.bsky.social" target="_blank" rel="noreferrer">
          Bluesky <FiArrowUpRight aria-hidden="true" />
        </a>
        <a href="mailto:jeromel@alleninstitute.org">
          Email <FiMail aria-hidden="true" />
        </a>
      </nav>
    </footer>
  );
}

export default SiteFooter;